import { render, staticRenderFns } from "./TablaRestriccion.vue?vue&type=template&id=ad7ed87e&scoped=true"
import script from "./TablaRestriccion.vue?vue&type=script&lang=js"
export * from "./TablaRestriccion.vue?vue&type=script&lang=js"
import style0 from "./TablaRestriccion.vue?vue&type=style&index=0&id=ad7ed87e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7ed87e",
  null
  
)

export default component.exports